import { render, staticRenderFns } from "./EmployeeChangePassword.vue?vue&type=template&id=e12efc26"
import script from "./EmployeeChangePassword.vue?vue&type=script&lang=js"
export * from "./EmployeeChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports